export const CQA_QUALITY_ASSESSMENT_GRADING_SCREEN =
  '/cmx/quality-assessment/workItem';

export const routedToGradingScreen = (route: string) => {
  return new RegExp(`${CQA_QUALITY_ASSESSMENT_GRADING_SCREEN}.*`).test(route);
};
